import { on, ready, query, queryAll } from './dom.js'
import { show, hide, ajaxPost, fireEvent } from './jsfunc.js'
import * as NavMenu from '../Widgets/NavMenu/NavMenu.js'

export function checkInputCart(input){
  var anzahl = input.value;
  var button = query('.shop.cart .Button.address');

  if(!anzahl.match(/^-?\d+$/)){
    if(input){
      input.classList.add('error');
    }
    if(button){
      button.setAttribute('disabled','disabled');
      button.classList.add('disabled');
    }
    return false;
  }else{
    if(input){
      input.classList.remove('error');
    }
    var errors = queryAll('input.error');
    if(button && errors.length == 0 ){
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
    }
  }
  return true;
}

export function setMindestmengeCart(input){
  var tdAnzahl = input.closest('td.anzahl');
  var anzahl = input.value;
  var mindestmenge = parseInt(tdAnzahl.getAttribute('data-mindestmenge'));
  var verfuegbar = parseInt(tdAnzahl.getAttribute('data-verfuegbar'));

  var artikel = input.closest('tr.item-data-numbers').getAttribute('data-artikel');
  var spanMindestmenge = document.querySelector('tr.item[data-artikel="'+artikel+'"] span.mindestmenge');
  var button = query('.shop.cart .Button.address');

  if(mindestmenge > 0){
    if(anzahl > verfuegbar && anzahl < mindestmenge){

      input.classList.add('error');
      if(spanMindestmenge){
        spanMindestmenge.classList.add('error');
      }
      if(button){
        button.setAttribute('disabled','disabled');
        button.classList.add('disabled');
      }

    }else{
      if(spanMindestmenge){
        spanMindestmenge.classList.remove('error');
      }
      input.classList.remove('error');
      if(button){
        if(queryAll('tr span.mindestmenge.error').length == 0){
          button.removeAttribute('disabled');
          button.classList.remove('disabled');
        }
      }
    }
  }
  var error = document.querySelector('.error');

  if(error){
    NavMenu.disableLinks();
  }else{
    NavMenu.enableLinks();
  }
  return anzahl;
}


export function setMindestmengePopup(event){
  var tdAnzahl = event.target.closest('td.anzahl');
  var anzahl = event.target.value;
  var mindestmenge = parseInt(tdAnzahl.getAttribute('data-mindestmenge'));
  var verfuegbar = parseInt(tdAnzahl.getAttribute('data-verfuegbar'));
  var artikel = event.target.closest('tr.item-data-numbers').getAttribute('data-artikel');

  if(mindestmenge > 0){
    if(anzahl > verfuegbar && anzahl < mindestmenge){
      event.target.value = mindestmenge;
      anzahl = mindestmenge;
    }
  }
  return anzahl;
}

export function checkInputPopup(input){
  var anzahl = input.value;

  if(!anzahl.match(/^-?\d+$/)){
    if(input){
      input.classList.add('error');
    }
    return false;
  }else{
    if(input){
      input.classList.remove('error');
    }
  }
  return true;
}

export function checkInputMindestmenge(input){
  if(checkInputCart(input)){
    var table = input.closest('table');
    var anzahl = setMindestmengeCart(input);
    if(anzahl > 0){
      ajaxPost(input.getAttribute('data-url'), {'anzahl': anzahl},
        function(request) {
          updateTable(JSON.parse(request.responseText), table);
        }
      );
    }else {
      var a = input.closest('tr').querySelector('a.loeschen');
      fireEvent(a, 'click');
    }
  }
}

export function updateTable(data, table) {
  var tr, tri;

  if(data['success'] && data['updatetable']){

    tr = table.querySelector('tr.item-data-numbers[data-artikel="'+data['artikel_name']+'"]');
    tri = table.querySelector('tr.item[data-artikel="'+data['artikel_name']+'"]');

    if(data['anzahl'] > 0){
      tr.querySelector('td.anzahl input').value = data['anzahl'];
      tr.querySelector('td.unitPrice span').textContent = data['einzelpreis'];
      tr.querySelector('td.totalPrice span').textContent = data['gesamtpreis'];

      if (data['aufschlag']) {
        show(table.querySelector('tr.minOrderPrice'));
      } else {
        hide(table.querySelector('tr.minOrderPrice'));
      }

    }else if(data['anzahl'] == 0){
      if(data['empty']){
        table.outerHTML = null;
        document.querySelector('.address').outerHTML = null;
        show('.empty');
      }
      var trs = table.querySelectorAll('tr[data-artikel="'+data['artikel_name']+'"]');
      for (var t=0;t<trs.length;++t){
        trs.item(t).outerHTML = null;
      }
    }

    if(data['aufschlag']){
      table.querySelector('tr.minOrderPrice td:last-of-type span').textContent = data['aufschlag'];
      show(table.querySelector('tr.minOrderPrice'));
    }else{
      hide(table.querySelector('tr.minOrderPrice'));
    }
    table.querySelector('tr.itemPrice td:last-of-type span').textContent = data['warenwert'];
    table.querySelector('tr.totalPrice td:last-of-type span').textContent = data['endpreis'];

    if(data['lieferzeit']){
      tri.querySelector('span.lieferzeit').outerHTML = data['lieferzeit'];
    }
  }

  if(!table.querySelector('tr[data-artikel]')) {
    table.outerHTML = null;
    document.querySelector('.address').outerHTML = null;
  }
  if(!document.querySelector('.NavMenu')){
    document.querySelector('.CartBox').outerHTML = data['cartbox'];
    document.querySelector('.infolayer-cart-popup').outerHTML = data['cartpopup'];
    show('.infolayer-cart-popup');
  }
}